import React, { useContext, useEffect, useState } from 'react';
import {
    Box,
    IconButton,
    Typography,
} from '@mui/material';
import {
    Check,
    Undo,
} from '@mui/icons-material';

import { HasPermissions } from '../../contexts/PermissionContext';
import ProjectContext from '../../contexts/ProjectContext';
import SettingsCheckBox from '../checkbox/SettingsCheckBox';
import SettingsTextField from '../textfield/SettingsTextField';
import _ from 'lodash';
import SettingsChipTextField from '../textfield/SettingsChipTextField';


function VFXPullsSettings({ schema={}, settings={}, setSettings = () => {} }) {

    const [vfxPullsSettings, setVfxPullsSettings] = useState(settings);

    useEffect(() => {
        setVfxPullsSettings(settings)
    }, [settings])

    function handleChange(field, value) {
        const updatedSettings = _.cloneDeep(vfxPullsSettings);
        updatedSettings[field] = value;
        updateSettings(updatedSettings);
    }

    function handleDiscard() {
        updateSettings(settings);
    }

    function updateSettings(newSettings) {
        setVfxPullsSettings(newSettings);
        setSettings(newSettings);
    }

    return (
        <Box
            display="flex"
            border={'1px solid rgba(139, 142, 146, 1)'}
            borderRadius={4}
            position="relative"
        >
            {/* {
                !_.isEqual(settings, vfxPullsSettings) && 
                <Box
                    position="absolute"
                    top={0}
                    right={0}
                    p={1}
                >
                    <IconButton
                        sx={{
                            color: 'rgba(180, 120, 120, 0.7)', // muted red
                            transition: 'color 0.2s',
                            '&:hover': {
                                color: 'rgb(211, 47, 47)', // vivid red
                            },
                        }}
                        onClick={handleDiscard}
                    >
                        <Undo
                            sx={{
                                fontSize: '16px',
                            }}
                        />
                    </IconButton>
                    <IconButton
                        sx={{
                            color: 'rgba(120, 180, 120, 0.7)', // muted green
                            fontSize: '16px',
                            transition: 'color 0.2s',
                            '&:hover': {
                                color: 'rgb(46, 225, 50)', // vivid green
                            },
                        }}
                    >
                        <Check
                            sx={{
                                fontSize: '16px',
                            }}
                        />
                    </IconButton>
                </Box>
            } */}
            <Box
                m={2}
                display="flex"
                flexDirection="column"
                gap={2}
            >
                <Typography
                    variant="h6"
                >
                    VFX Pulls Settings
                </Typography>

                <SettingsCheckBox
                    description={schema?.data?.cloud?.description ?? ''}
                    disabled={!HasPermissions(schema?.permissions?.write)}
                    label={schema?.data?.cloud?.label ?? 'Cloud'}
                    onChange={(value) => handleChange('cloud', value)}
                    options={schema?.data?.cloud?.options ?? []}
                    original={settings?.cloud ?? ''}
                    value={vfxPullsSettings?.cloud ?? ''}
                />

                <SettingsCheckBox
                    description={schema?.data?.s3_media?.description ?? ''}
                    disabled={!HasPermissions(schema?.permissions?.write)}
                    label={schema?.data?.s3_media?.label ?? 'Media in S3'}
                    onChange={(value) => handleChange('s3_media', value)}
                    options={schema?.data?.s3_media?.options ?? []}
                    original={settings?.s3_media ?? ''}
                    value={vfxPullsSettings?.s3_media ?? ''}
                />

                <SettingsTextField
                    description={schema?.data?.projectbasepath?.description ?? ''}
                    disabled={!HasPermissions(schema?.permissions?.write)}
                    label={schema?.data?.projectbasepath?.label ?? 'Project Base Path'}
                    onChange={(value) => handleChange('projectbasepath', value)}
                    original={settings?.projectbasepath ?? ''}
                    value={vfxPullsSettings?.projectbasepath ?? ''}
                />

                <SettingsTextField
                    description={schema?.data?.result_exr_path?.description ?? ''}
                    disabled={!HasPermissions(schema?.permissions?.write)}
                    label={schema?.data?.result_exr_path?.label ?? 'Result EXR Path'}
                    onChange={(value) => handleChange('result_exr_path', value)}
                    original={settings?.result_exr_path ?? ''}
                    value={vfxPullsSettings?.result_exr_path ?? ''}
                />

                <SettingsTextField
                    description={schema?.data?.default_start_frame?.description ?? ''}
                    disabled={!HasPermissions(schema?.permissions?.write)}
                    label={schema?.data?.default_start_frame?.label ?? 'Default Start Frame'}
                    onChange={(value) => handleChange('default_start_frame', value)}
                    original={settings?.default_start_frame ?? ''}
                    value={vfxPullsSettings?.default_start_frame ?? ''}
                />

                <SettingsTextField
                    description={schema?.data?.default_frame_buffer?.description ?? ''}
                    disabled={!HasPermissions(schema?.permissions?.write)}
                    label={schema?.data?.default_frame_buffer?.label ?? 'Default Frame Buffer'}
                    onChange={(value) => handleChange('default_frame_buffer', value)}
                    original={settings?.default_frame_buffer ?? ''}
                    value={vfxPullsSettings?.default_frame_buffer ?? ''}
                />

                <SettingsChipTextField
                    description={`List of Pull Types`}
                    disabled={!HasPermissions(schema?.permissions?.write)}
                    label='Pull Types'
                    onChange={(values) => handleChange('pulltype', values.map(name => ({name})))}
                    original={settings?.pulltype?.map(pt => pt.name) ?? []}
                    values={vfxPullsSettings?.pulltype?.map(pt => pt.name) ?? []}
                />

            </Box>
        </Box>
    );
}

export default VFXPullsSettings;